<template>
  <div v-if="plan">
    <div v-if="!paymentsUpToDate(plan)">
      <Alert type="error">
        La résiliation ne peut pas être effectuée tant que tous vos paiements ne sont pas à jour.
        <br />
        Merci de régulariser votre situation depuis l'onglet
        <strong>Factures</strong>
        afin de pouvoir poursuivre.
      </Alert>
    </div>
    <Alert v-else-if="fullContractCommitment(plan) && !plan.cancellationAvailable" type="info">
      La résiliation ne peut pas être effectuée.
      <br />
      Votre contrat est
      <strong>engageant</strong>
      jusqu'à son expiration.
    </Alert>
    <CancellationFlow v-else :plan="plan" />
  </div>
  <Loading v-else />
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CancellationFlow from "@/components/cancellation/CancellationFlow.vue";
import { Loading, Alert } from "@estaly/ui";

export default {
  components: {
    CancellationFlow,
    Loading,
    Alert,
  },

  data() {
    return {
      plan: null,
    };
  },

  computed: {
    ...mapState("customer", ["plans"]),
    ...mapGetters("planSales", ["paymentsUpToDate"]),
    ...mapGetters("cancellations", ["fullContractCommitment"]),
  },

  watch: {
    "$route.params.id": {
      immediate: true,
      handler(newValue) {
        if (newValue) this.setPlan();
      },
    },
  },

  methods: {
    setPlan() {
      this.plan = this.plans.find((plan) => plan.friendlyId === this.$route.params.id);
    },
  },
};
</script>
